import { useEffect, useContext, useState } from 'react';
import { trackClientPageview } from './client-event-tracking';
import { trackComscorePageview } from './comscore/client';
import { trackFacebookPageView } from './facebook/client';
import { trackOutbrainPageView } from './outbrain/client';
import { trackPermutivePageView } from './permutive/client';
import { trackYahooPageview } from './yahoo/client';
import { getReferrer } from '@buzzfeed/bf-utils/lib/referrer';
import ABeagleContext from '../../contexts/abeagle';
import DestinationContext from '../../contexts/destination';
import ConsentContext from '../../contexts/consent';
import { isPermutiveDisabled } from './utils';

export function usePageviewTracking(buzz) {
  const [disableNonShoppingPermutive, setDisableNonShoppingPermutive] = useState(null);
  const {
    getFeatureFlagValue,
    experiments,
    getExperimentValue
  } = useContext(ABeagleContext);

  useEffect(() => {
    if (experiments && experiments.loaded) {
      setDisableNonShoppingPermutive(
        getExperimentValue('ads_permutive_non_shopping', {
          rejectErrors: false,
        })
      );
    }
  }, [experiments, getExperimentValue]);

  const { destination } = useContext(DestinationContext);
  // Do not allow permutive script on arbitrage pages
  const isPermutiveEnabled = getFeatureFlagValue('ADSGROUP-442-permutive') && !isPermutiveDisabled(buzz);
  const {tracking: { consentValue, isConsentReady }} = useContext(ConsentContext);

  const shouldTrackPermutive =
    isPermutiveEnabled &&
    (
      buzz.isShopping ||
      (experiments?.loaded && disableNonShoppingPermutive === 'control')
    );

  useEffect(() => {
    trackClientPageview(buzz);

    // Facebook will check consent independently
    trackFacebookPageView(destination, buzz, {
      section: buzz.classification.section,
      Edition: buzz.classification.edition,
      username: buzz.bylines[0].username,
      tags: buzz.tags,
      SocialReferral: getReferrer(),
    });
  }, [buzz, destination]);

  useEffect(() => {
    if (shouldTrackPermutive) {
      // Permutive will check consent independently
      trackPermutivePageView(buzz);
    }
  }, [buzz, shouldTrackPermutive]);

  useEffect(() => {
    if (isConsentReady && consentValue) {
      trackOutbrainPageView();
      if (buzz.classification.edition === 'Japan') {
        trackYahooPageview();
      }
    }
  }, [buzz, consentValue, destination, isConsentReady]);

  useEffect(() => {
    trackComscorePageview();
  }, [buzz]);
}
